import React, { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { RHFInput } from '@/Components/shadcn/rhf-input';
import UIStrings from '@/Utils/UIStrings';
import { JobDetailsFieldTypes, useJobDetailsForm } from '../JobDetailsStepUtils';

function YearlySalaryRange(): React.JSX.Element {
    const { control, formState, setValue, trigger } = useJobDetailsForm();
    const { yearlySalaryFrom, doNotDisplaySalary } = useWatch({ control });

    useEffect(() => {
        if (formState.touchedFields.yearlySalaryFrom) {
            trigger('yearlySalaryTo');
        }
    }, [formState.touchedFields.yearlySalaryFrom, yearlySalaryFrom]);

    useEffect(() => {
        if (doNotDisplaySalary) {
            setValue('yearlySalaryFrom', undefined!, { shouldTouch: false, shouldValidate: true });
            setValue('yearlySalaryTo', undefined!, { shouldTouch: false, shouldValidate: true });
        }
    }, [doNotDisplaySalary]);

    return (
        <div className="flex min-w-0 flex-1 flex-col gap-3">
            <span className="text-foreground text-sm leading-none font-medium">{`${UIStrings.YearlySalaryRange}*`}</span>
            <div className="flex flex-row items-center gap-2">
                <RHFInput
                    hideLabel
                    useNumberFormatter
                    hideFieldError
                    name={JobDetailsFieldTypes.YearlySalaryFrom}
                    fieldDataCy={JobDetailsFieldTypes.YearlySalaryFrom}
                    disabled={doNotDisplaySalary}
                    className="min-w-0 flex-1"
                />
                <span className="text-foreground text-sm font-semibold">-</span>
                <RHFInput
                    hideLabel
                    useNumberFormatter
                    hideFieldError
                    name={JobDetailsFieldTypes.YearlySalaryTo}
                    fieldDataCy={JobDetailsFieldTypes.YearlySalaryTo}
                    disabled={doNotDisplaySalary}
                    className="min-w-0 flex-1"
                />
            </div>
        </div>
    );
}

export default YearlySalaryRange;
